export const MEDIA_MONITORING_META_DESCRIPTION_BG =
  "Perceptica предлага медиен мониторинг на печатни, онлайн, радио, телевизионни и социални медии в Югоизточна Европа с данни в реално време, сигнали и задълбочен анализ.";
